import React from 'react';

import MainLayout from '../../components/Layout/MainLayout';
import HeroCarousel from './components/HeroCarousel';
import PopularBooks from './components/PopularBooks';
import BestSellers from './components/BestSellers';
import SellerShowcase from './components/SellerShowcase';
import StatsCounter from './components/StatsCounter';

export default function Home() {
  return (
    <MainLayout>
      <HeroCarousel />
      <PopularBooks />
      <BestSellers />
      <SellerShowcase />
      <StatsCounter />
    </MainLayout>
  );
}
